import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Starlight Threading. All rights reserved.</p>
    </footer>
  );
}
